import React, { useEffect, useState } from 'react';

import { useQuery } from '@apollo/client';
import { faArrowRightArrowLeft, faLock, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useHasLeaderBoard from 'hooks/useHasLeaderBoard';
import PropTypes from 'prop-types';
import { Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import defaultAvatar from '../../assets/img/default_pictures/avatar.png';
import auth from '../../services/Auth';
import documentsRequest from '../../services/documents/gqlSchema';

const propTypes = {
  notif: PropTypes.bool,
  accnt: PropTypes.bool,
  tasks: PropTypes.bool,
  mssgs: PropTypes.bool,
};
const defaultProps = {
  notif: false,
  accnt: false,
  tasks: false,
  mssgs: false,
};

const DefaultHeaderDropdown = props => {
  const { notif, accnt, tasks, mssgs } = props;

  const currentContact = auth.getContact();

  let contactParams = {};

  // Find contactInfos with company
  if (currentContact.isAgent) {
    contactParams = {
      sources: {
        hasExternalId: true,
        active: true,
      },
      company: {
        hasCompany: true,
      },
    };
  } else if (currentContact.isServiceProvider) {
    contactParams = {
      sources: {
        active: true,
      },
    };
  } else {
    contactParams = {
      company: {
        hasCompany: true,
      },
    };
  }

  const currentContactInfo = auth.findContactsInfos(contactParams);
  const hasLeaderBoard = useHasLeaderBoard();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [avatar, setAvatar] = useState(null);

  const fetchAvatar = useQuery(documentsRequest.Query.contactInfoPictures, {
    variables: {
      contactsInfoId: currentContactInfo[0]?.id,
    },
  });

  const firstname = currentContactInfo[0]?.firstname;
  const name = currentContactInfo[0]?.name;

  const { code: companyCode = '' } = auth?.findUserCompany() || {};
  const boardUrl =
    companyCode === 'CAPIFRANCE' ? process.env.REACT_APP_HORIZON_URL : process.env.REACT_APP_LEADERBOARD_URL;
  const boardLabel = companyCode === 'CAPIFRANCE' ? 'Horizon' : 'Espace Leader';

  useEffect(() => {
    const { loading, data } = fetchAvatar;
    if (!loading) {
      setAvatar(
        data?.contactInfoPictures &&
          data.contactInfoPictures[data.contactInfoPictures.length - 1] &&
          data.contactInfoPictures[data.contactInfoPictures.length - 1].public_url,
      );
    }
  }, [fetchAvatar]);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    auth.logout();
    window.location.reload();
  };

  const goTo = route => {
    props.history.push(`${route}`);
  };

  const dropNotif = () => {
    const itemsCount = 5;

    return (
      <Dropdown nav className='d-md-down-none' isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav>
          <i className='icon-bell' />
          <Badge pill color='danger'>
            {itemsCount}
          </Badge>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header tag='div' className='text-center'>
            <strong>Vous avez {itemsCount} notifications</strong>
          </DropdownItem>
          <DropdownItem>
            <i className='icon-user-follow text-success' /> 3 nouveaux leads à traiter
          </DropdownItem>
          <DropdownItem>
            <i className='icon-user-unfollow text-danger' /> 1 lead perdu
          </DropdownItem>
          <DropdownItem>
            <i className='icon-envelope text-info' /> 7 demandes de renseignements
          </DropdownItem>
          <DropdownItem>
            <i className='icon-docs text-primary' /> 3 Nouveaux documents
          </DropdownItem>
          <DropdownItem>
            <i className='icon-speech text-warning' /> 2 Nouvelles actualités
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const Item = ({ icon, children }) => (
    <>
      <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} /> {children}
    </>
  );

  const dropAccnt = () => {
    if (!currentContact) {
      return <div />;
    }

    return (
      <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav>
          <img src={avatar || defaultAvatar} className='img-avatar' alt='avatar' />
          <span className='d-md-down-none mr-3'>
            {firstname} {name}
          </span>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => goTo('/account')}>
            <Item icon={faUser}>Mon compte</Item>
          </DropdownItem>
          {hasLeaderBoard && (
            <DropdownItem onClick={() => window.open(boardUrl, '_blank').focus()}>
              <Item icon={faArrowRightArrowLeft}>{boardLabel}</Item>
            </DropdownItem>
          )}
          <DropdownItem onClick={handleLogout}>
            <Item icon={faLock}>Déconnexion</Item>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const dropTasks = () => {
    const itemsCount = 5;

    return (
      <Dropdown nav className='d-md-down-none' isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav>
          <i className='icon-calendar' />
          <Badge pill color='warning'>
            {itemsCount}
          </Badge>
        </DropdownToggle>
        <DropdownMenu className='dropdown-menu-lg'>
          <DropdownItem header tag='div' className='text-center'>
            <strong>Vous avez {itemsCount} RDV aujourd'hui</strong>
          </DropdownItem>
          <DropdownItem>
            <div className='small mb-1'>
              Visite xxxxxxxxxxx
              <span className='float-right'>
                <strong>10h00</strong>
              </span>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className='small mb-1'>
              Visite xxxxxxxxxxx
              <span className='float-right'>
                <strong>11h00</strong>
              </span>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className='small mb-1'>
              Visite xxxxxxxxxxx
              <span className='float-right'>
                <strong>14h00</strong>
              </span>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className='small mb-1'>
              Visite xxxxxxxxxxx
              <span className='float-right'>
                <strong>15h00</strong>
              </span>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className='small mb-1'>
              Visite xxxxxxxxxxx
              <span className='float-right'>
                <strong>16h00</strong>
              </span>
            </div>
          </DropdownItem>
          <DropdownItem className='text-center'>
            <strong>Voir votre agenda</strong>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const dropMssgs = () => {
    const itemsCount = 42;

    return (
      <Dropdown nav className='d-md-down-none' isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav>
          <i className='icon-envelope-letter' />
          <Badge pill color='info'>
            {itemsCount}
          </Badge>
        </DropdownToggle>
        <DropdownMenu className='dropdown-menu-lg'>
          <DropdownItem header tag='div'>
            <strong>Vous avez {itemsCount} messages</strong>
          </DropdownItem>
          <DropdownItem onClick={() => goTo('/inbox/read')}>
            <div className='message'>
              <div className='pt-3 mr-3 float-left'>
                <div className='avatar'>
                  <img src={'../../assets/img/avatars/7.jpg'} className='img-avatar' alt='admin@bootstrapmaster.com' />
                  <span className='avatar-status badge-success' />
                </div>
              </div>
              <div>
                <small className='text-muted'>John Doe</small>
                <small className='text-muted float-right mt-1'>Maintenant</small>
              </div>
              <div className='text-truncate font-weight-bold'>
                <span className='fa fa-exclamation text-danger' /> Message important
              </div>
              <div className='small text-muted text-truncate'>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
              </div>
            </div>
          </DropdownItem>
          <DropdownItem onClick={() => goTo('/inbox/read')}>
            <div className='message'>
              <div className='pt-3 mr-3 float-left'>
                <div className='avatar'>
                  <img src={'../../assets/img/avatars/6.jpg'} className='img-avatar' alt='admin@bootstrapmaster.com' />
                  <span className='avatar-status badge-warning' />
                </div>
              </div>
              <div>
                <small className='text-muted'>Jane Doe</small>
                <small className='text-muted float-right mt-1'>Il y a 5 minutes</small>
              </div>
              <div className='text-truncate font-weight-bold'>Lorem ipsum dolor sit amet</div>
              <div className='small text-muted text-truncate'>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
              </div>
            </div>
          </DropdownItem>
          <DropdownItem onClick={() => goTo('/inbox/read')}>
            <div className='message'>
              <div className='pt-3 mr-3 float-left'>
                <div className='avatar'>
                  <img src={'../../assets/img/avatars/5.jpg'} className='img-avatar' alt='admin@bootstrapmaster.com' />
                  <span className='avatar-status badge-danger' />
                </div>
              </div>
              <div>
                <small className='text-muted'>Janet Doe</small>
                <small className='text-muted float-right mt-1'>À 13h52</small>
              </div>
              <div className='text-truncate font-weight-bold'>Lorem ipsum dolor sit amet</div>
              <div className='small text-muted text-truncate'>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
              </div>
            </div>
          </DropdownItem>
          <DropdownItem onClick={() => goTo('/inbox/read')}>
            <div className='message'>
              <div className='pt-3 mr-3 float-left'>
                <div className='avatar'>
                  <img src={'../../assets/img/avatars/4.jpg'} className='img-avatar' alt='admin@bootstrapmaster.com' />
                  <span className='avatar-status badge-info' />
                </div>
              </div>
              <div>
                <small className='text-muted'>Joe Doe</small>
                <small className='text-muted float-right mt-1'>À 16h03</small>
              </div>
              <div className='text-truncate font-weight-bold'>Lorem ipsum dolor sit amet</div>
              <div className='small text-muted text-truncate'>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...
              </div>
            </div>
          </DropdownItem>
          <DropdownItem onClick={() => goTo('/inbox')} className='text-center'>
            <strong>Voir tous les messages</strong>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return notif ? dropNotif() : accnt ? dropAccnt() : tasks ? dropTasks() : mssgs ? dropMssgs() : null;
};

DefaultHeaderDropdown.propTypes = propTypes;
DefaultHeaderDropdown.defaultProps = defaultProps;

export default DefaultHeaderDropdown;
